import {type Json, matchJson, getObject} from '@packages/utilities/json';
import {
  type Expression,
  ERecord,
  ECase,
  EText,
  EList,
  ECall,
  EFunction,
} from '@packages/systems/wfdl-ast';
import {$, func, call, call1, _$} from '@packages/utilities/wfdl-helpers';
import {
  toBooleanRef,
  toNumberRef,
  toTextRef,
} from '@packages/systems/plugins/Json';
import {lookupRef} from '@packages/systems/plugins/List';

const id = func(['x'], $('x'));

const none = func(['_'], _$('Option', 'None'));
const toNameValuePairsRef = _$('Json', 'To Name & Value pairs');
const toNameValuePairs = call1(toNameValuePairsRef);

// @ts-expect-error - TS7006 - Parameter 'label' implicitly has an 'any' type.
const getField = (label) => call(lookupRef, [EText(label), $('pairs')]);

const giveEmptyList = func(['_'], EList([]));

const toPairs = func(
  ['json'],
  ECase({
    value: toNameValuePairs($('json')),
    cases: {
      None: giveEmptyList,
      Some: id,
    },
  })
);

const parseRecord = (obj: {[key: string]: Json}) =>
  func(
    ['pairs'],
    ERecord(
      Object.keys(obj).reduce<Record<string, any>>((acc, label) => {
        const json = obj[label];
        // @ts-expect-error - TS2345 - Argument of type 'Json | undefined' is not assignable to parameter of type 'Json'.
        const innerObj = getObject(json);

        if (!innerObj) {
          acc[label] =
            // `Option Json` for null and array since we don’t support them
            json === null || Array.isArray(json)
              ? getField(label)
              : ECase({
                  value: getField(label),
                  cases: {
                    None: none,
                    // @ts-expect-error - TS2345 - Argument of type 'string | number | boolean | { [key: string]: Json; } | undefined' is not assignable to parameter of type 'Json'.
                    Some: guessJsonParser(json),
                  },
                });
          // Ignore empty objects
        } else if (Object.keys(innerObj).length > 0) {
          acc[label] = call(parseRecord(innerObj), [
            ECase({
              value: getField(label),
              cases: {
                None: giveEmptyList,
                Some: toPairs,
              },
            }),
          ]);
        }

        return acc;
      }, {})
    )
  );

export const guessJsonParser: (arg1: Json) => Expression = matchJson({
  Null: (_) => id,
  Boolean: (_) => toBooleanRef,
  Number: (_) => toNumberRef,
  String: (_) => toTextRef,
  Array: (_) => id,
  Object: (obj) =>
    func(['json'], call(parseRecord(obj), [call(toPairs, [$('json')])])),
});

export const createJsonParserToEffect: (arg1: Json) => Expression = (json) =>
  EFunction({
    param: 'json',
    body: ECall({
      fun: _$('Effect', 'pure'),
      arg: ECall({
        fun: guessJsonParser(json),
        arg: $('json'),
      }),
    }),
  });
